import React, { Fragment } from 'react'
import TopBanner from "../../Components/Main/TopBanner";
import ContactDetail from '../../Components/ContactUs/ContactDetail';
const ContactUs = () => {
    return (
        <Fragment>
            <TopBanner title={"Contact Us"} />
            <ContactDetail />
        </Fragment>
    )
}

export default ContactUs